import Links from "../Links/Links";

import "./Footer.css";

export default function Footer() {
  return (
    <>
      <div className="footerContainer">
        <h4>Copyright 2022 Streetlab. All rights reserved.</h4>
        <Links />
      </div>
    </>
  );
}
